<template>
  <div>
    <vs-popup
      classContent="popup-example"
      title="Create Lead"
      :active.sync="isSidebarActiveLocal"
    >
      <form data-vv-scope="Add_Lead" class="sidebar-scrollable-form">
        <div class="vx-row">
          <span style="color: green">{{ api_response_message }}</span>
          <div class="vx-col w-full">
            <form data-vv-scope="Add_Lead">
              <div class="my-2 flex">
                <span class="mr-5">Parent with Minor</span>
                <vs-switch v-model="lead.multi_user" />
              </div>

              <vs-row vs-type="flex">
                <vs-col
                  v-for="field in staticFields"
                  :key="field.id"
                  :vs-w="fieldColValue(field)"
                  class="mt-2"
                >
                  <label class="vs-input--label w-full"
                    >{{ field.field_label
                    }}<span v-if="field.enabled_parent" class="required"></span
                  ></label>
                  <vs-input
                    v-if="
                      field.field_name != 'platform_customer_countries_id' &&
                      field.field_name != 'email' &&
                      field.field_name != 'phone'
                    "
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    v-model="lead[field.field_name]"
                    class="custom_Input"
                    :name="field.field_label"
                    style="width: 100%"
                  />
                  <vs-input
                    v-else-if="field.field_name == 'phone'"
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    v-model="lead[field.field_name]"
                    class="custom_Input"
                    :name="field.field_label"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57 || event.charCode==43)"
                    style="width: 100%"
                  />
                  <vs-input
                    v-else-if="field.field_name == 'email'"
                    v-validate="
                      field.enabled_parent == true ? 'required|email' : ''
                    "
                    v-model="lead[field.field_name]"
                    class="custom_Input"
                    :name="field.field_label"
                    style="width: 100%"
                  />
                  <v-select
                    v-else
                    v-model="lead[field.field_name]"
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    :reduce="(option) => option.id"
                    label="country_name"
                    :name="field.field_label"
                    :options="countryList"
                    style="width: 100%"
                  />
                  <div
                    class="flex items-center"
                    style="color: rgba(var(--vs-primary), 1); font-size: 12px"
                    v-if="field.field_label == 'Phone'"
                  >
                    <span
                      style="font-size: 14px; margin-right: 2px"
                      class="material-icons-outlined"
                      >info</span
                    >Country code is mandatory.
                  </div>
                  <span
                    v-show="errors.has(`Add_Lead.${field.field_label}`)"
                    class="text-danger"
                    >{{ errors.first(`Add_Lead.${field.field_label}`) }}</span
                  >
                </vs-col>
              </vs-row>

              <vs-row v-if="addChildFrom" class="mt-2">
                <div
                  v-for="(item, index) of lead.children"
                  :key="index"
                  class="child-section"
                >
                  <vs-row
                    class="flex flex-wrap justify-between items-center"
                    vs-justify="space-between"
                    vs-align="space-between"
                  >
                    <h5 class="child-detail-heading">Child Details</h5>
                    <div class="flex">
                      <feather-icon
                        icon="Trash2Icon"
                        svgClasses="h-6 w-6"
                        class="align-middle text-danger mr-3"
                        @click="handledeleteChild(index)"
                      />
                      <vs-icon
                        icon-pack="feather"
                        :icon="
                          item.hide ? 'icon-chevron-down' : 'icon-chevron-left'
                        "
                        style="font-size: 20px"
                        @click="item.hide = !item.hide"
                      />
                    </div>
                    <vs-checkbox
                      v-model="sameasparentAddress"
                      @change="abc(index)"
                      class="custom_Input mt-5 mb-2"
                      :vs-value="`child_${index}`"
                      style="width: 100%"
                      >Same as Parent's Address</vs-checkbox
                    >

                    <!-- <vs-icon color="danger" icon="delete" @click="handledeleteChild(index)"/> -->
                  </vs-row>

                  <vs-row>
                    <vs-col
                      class="mt-1"
                      v-for="childfield in staticChildFields"
                      :vs-w="fieldColValue(childfield)"
                      :key="childfield.id"
                    >
                      <label class="vs-input--label w-full"
                        >{{ childfield.field_label
                        }}<span
                          v-if="childfield.enabled_child"
                          class="required"
                        ></span
                      ></label>
                      <vs-input
                        v-if="
                          childfield.field_name !=
                          'platform_customer_countries_id' && childfield.field_name != 'phone'
                        "
                        v-model="item[childfield.field_name]"
                        v-validate="
                          childfield.enabled_child == true ? 'required' : ''
                        "
                        :data-vv-name="`child ${childfield.field_label}`"
                        :name="`child ${childfield.field_name}`"
                        class="custom_Input"
                        style="width: 100%"
                      />
                      <vs-input
                        v-else-if="childfield.field_name =='phone'"
                        v-model="item[childfield.field_name]"
                        v-validate="childfield.enabled_child == true ? 'required' : ''"
                        :data-vv-name="`child ${childfield.field_label}`"
                        :name="`child ${childfield.field_name}`"
                        class="custom_Input"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57 || event.charCode==43)"
                        style="width: 100%"
                      />
                      <v-select
                        v-else
                        :data-vv-name="`child ${childfield.field_label}`"
                        v-model="item[childfield.field_name]"
                        v-validate="
                          childfield.enabled_child == true ? 'required' : ''
                        "
                        :reduce="(option) => option.id"
                        label="country_name"
                        :name="`child ${childfield.field_name}`"
                        :options="countryList"
                        style="width: 100%"
                      />
                      <div
                        class="flex items-center"
                        style="
                          color: rgba(var(--vs-primary), 1);
                          font-size: 12px;
                        "
                        v-if="childfield.field_label == 'Phone'"
                      >
                        <span
                          style="font-size: 14px; margin-right: 2px"
                          class="material-icons-outlined"
                          >info</span
                        >Country code is mandatory.
                      </div>
                      <span
                        v-show="
                          errors.has(`Add_Lead.child ${childfield.field_label}`)
                        "
                        class="text-danger"
                        >{{
                          errors.first(
                            `Add_Lead.child ${childfield.field_label}`
                          )
                        }}</span
                      >
                    </vs-col>
                  </vs-row>
                </div>
                <vs-row type="flex" vs-justify="flex-end">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-user-plus"
                    class="mt-2"
                    @click="handleAddMinor"
                    >Add Child</vs-button
                  >
                </vs-row>
              </vs-row>
              <!-- For Dynamic Field required Labels-->
              <!-- <pre>{{custom_fields_required}}</pre> -->
              <dynamic-component
                class="mt-2"
                ref="children"
                :custom_fields_required="custom_fields_required"
                validatorScope="Add_Lead"
                v-model="dynamicFormObject"
              ></dynamic-component>
            </form>
            <!-- {{form}} -->
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col flex">
            <vs-button
              color="primary"
              type="filled"
              style="font-size: 13.8px; padding: 9px"
              class="mr-3"
              @click="create_leads('saveandclose')"
              >Save</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              style="font-size: 13.8px; padding: 9px"
              class="mr-3"
              @click="create_leads('saveandopen')"
              >Save &amp; Open</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              style="font-size: 13.8px; padding: 9px"
              @click="create_leads('saveandaddanother')"
              >Save &amp; Add Another</vs-button
            >
          </div>
        </div>
      </form>
      <!-- </div> -->
      <!-- End chnages made by Sujay Ghosh -->
    </vs-popup>
  </div>
</template>

<script>
import { create_lead } from '@/api/leads'
import DynamicComponent from '@/components/common/DynamicComponent'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

import 'flatpickr/dist/flatpickr.css'
export default {
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          /* this.$validator.errors.clear('Add_Lead')
          this.$refs.children.$validator.errors.clear('Add_Lead') */
          this.$validator.reset()
          this.$refs.children.$validator.reset()
          this.$emit('closeSidebar', false)
        }
      }
    },
  },

  props: {
    isSidebarActive: {},
    countryList: {
      type: Array,
      required: true,
      default: () => []
    },
    custom_fields_required: {
      type: Array,
      required: true,
      default: () => []
    },
    dynamicFormObject: {
      type: Object,
      required: true,
      default: () => { }
    },
    staticFields: {
      type: Array,
      required: true,
      default: () => []
    },
    staticChildFields: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      sameasparentAddress: [],
      lead: {
        customer_id: this.$store.getters.customerId,
        multi_user: false,
        children: [],
        lead_first_name: '',
        lead_middle_name: '',
        lead_last_name: '',
        lead_address1: '',
        lead_address2: '',
        lead_state: '',
        lead_zip: '',
        lead_city: '',
        platform_customer_countries_id: 1,
        email: '',
        phone: null
      },
      addChildFrom: false,

      errorCount: 0,
      api_response_message_show: false,
      api_response_message: '',
      leadPersonaList: [
        { value: 0, name: 'Individual' },
        { value: 1, name: 'Minor With Parent' }
      ]
    }
  },
  components: {
    DynamicComponent,
    flatPickr,
    vSelect
  },
  watch: {
    lead: {
      deep: true,
      handler () {
        if (this.lead.multi_user === true) {
          this.addChildFrom = true
        } else {
          this.addChildFrom = false
        }
      }
    },
    addChildFrom () {
      if (!this.addChildFrom) {
        this.lead.children = [
          {
            customer_id: this.$store.getters.customerId,
            lead_first_name: null,
            lead_last_name: null,
            lead_middle_name: null,
            email: null,
            phone: null,
            lead_address1: null,
            lead_address2: null,
            lead_city: null,
            lead_state: null,
            lead_zip: null,
            platform_customer_countries_id: 1,
            multi_user: false
          }
        ]
      }
    }
  },
  mounted () {
    console.log(this.staticFields)
  },
  methods: {
    fieldColValue (field) {
      const { field_name } = field

      if (['lead_first_name', 'lead_middle_name', 'lead_last_name'].includes(field_name)) return 4
      if (['lead_address1', 'lead_address2'].includes(field_name)) return 12

      return 6
    },
    handledeleteChild (index) {
      this.lead.children.splice(index, 1)
    },
    abc (index) {
      const is_active = this.sameasparentAddress.findIndex(
        (item) => item === `child_${index}`
      )
      if (is_active > -1) {
        this.lead.children[index].lead_address1 = this.lead.lead_address1
        this.lead.children[index].lead_address2 = this.lead.lead_address2
        this.lead.children[index].lead_state = this.lead.lead_state
        this.lead.children[index].lead_zip = this.lead.lead_zip
        this.lead.children[index].lead_city = this.lead.lead_city
        this.lead.children[index].platform_customer_countries_id =
          this.lead.platform_customer_countries_id
        //this.sameasparentAddress = false
      } else {
        this.lead.children[index].lead_address1 = ''
        this.lead.children[index].lead_address2 = ''
        this.lead.children[index].lead_state = ''
        this.lead.children[index].lead_zip = ''
        this.lead.children[index].lead_city = ''
        this.lead.children[index].platform_customer_countries_id = ''
      }
    },
    handleAddMinor () {
      //add child function
      const payload = {
        customer_id: this.$store.getters.customerId,
        lead_first_name: null,
        lead_last_name: null,
        lead_middle_name: null,
        email: null,
        phone: null,
        lead_address1: null,
        lead_address2: null,
        lead_city: null,
        lead_state: null,
        lead_zip: null,
        platform_customer_countries_id: 1,
        multi_user: false
      }
      this.lead.children.push(payload)
    },
    create_leads (sidebar_close_status) {
      try {
        this.api_response_message_show = false

        const validateParent = this.$validator.validateAll('Add_Lead')
        const childDynamicComponent =
          this.$refs.children.$validator.validateAll('Add_Lead')
        const validateAll = Promise.all([
          validateParent,
          childDynamicComponent
        ])
        const phoneFlag = 0;
        if (this.lead.phone.length !== 10 && this.lead.platform_customer_countries_id === 1) {
          this.$vs.notify({
            title: 'Error',
            text: 'Phone number should be 10 digits',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          phoneFlag = 1
        } else if (![9, 8, 7, 6].includes(Number(String(this.lead.phone).charAt(0))) && this.lead.platform_customer_countries_id === 1) {
          this.$vs.notify({
            title: 'Error',
            text: 'Phone number is incorrect',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          phoneFlag = 1
        }
        this.lead.children.forEach((child) => {
          if (isNaN(child.phone)) {
            this.$vs.notify({
              title: 'Error',
              text: 'Phone number should be digit only',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            phoneFlag = 1
          } else if (child.phone.length !== 10 && child.platform_customer_countries_id === 1) {
            this.$vs.notify({
              title: 'Error',
              text: 'Phone number should be 10 digits',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            phoneFlag = 1
          } else if (![9, 8, 7, 6].includes(Number(String(child.phone).charAt(0))) && child.platform_customer_countries_id === 1) {
            this.$vs.notify({
              title: 'Error',
              text: 'Phone number is incorrect',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            phoneFlag = 1
          }
        })

        if (phoneFlag === 1) {
          return false
        }

        validateAll.then((valid) => {
          if (!valid.includes(false)) {
            // const request_parameter = {
            //   customer_id: this.$store.getters.customerId,
            //   email: this.email,
            //   phone: this.phone,
            //   lead_first_name: this.lead_first_name,
            //   lead_middle_name: this.lead_middle_name,
            //   lead_last_name: this.lead_last_name,
            //   lead_address1: this.lead_address1,
            //   lead_address2: this.lead_address2,
            //   platform_customer_countries_id: this.platform_customer_countries_id,
            //   lead_state: this.lead_state,
            //   lead_zip: this.lead_zip,
            //   lead_city: this.lead_city,
            //   multi_user: this.lead.multi_user,
            //   children:this.lead.children
            // }

            this.creatingLead(this.lead, sidebar_close_status)
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'All required Fields Are Mandatory',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
              // position: 'top-center',
            })
          }
        })
      } catch (e) {
        console.log(e.data)
      }
    },
    async creatingLead (request_parameter, sidebar_close_status) {
      this.$vs.loading({ text: 'Please wait while lead is being created' })
      try {
        const attchedDynamicFieldObject = {
          dynamic_fields: {}
        }
        attchedDynamicFieldObject.dynamic_fields = this.dynamicFormObject

        //assigning form values into object dynamic fields

        //
        const parameter = Object.assign(
          {},
          request_parameter,
          attchedDynamicFieldObject
        )
        const response = await create_lead(parameter)

        const leadObject = response.data.data.leads_details

        this.setDefault()
        this.$vs.notify({
          title: 'Success',
          text: 'Lead created Successfully.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
          // position: 'top-center',
        })
        if (sidebar_close_status === 'saveandclose') {
          leadObject.saveType = 'SaveAndClose'
          this.$emit('closeSidebar', leadObject)
        } else if (sidebar_close_status === 'saveandaddanother') {
          leadObject.saveType = 'SaveAndAnother'
          this.$emit('closeSidebar', leadObject)
        } else {
          const leadid = leadObject.leads_id

          //temp changes
          setTimeout(() => {
            this.$router.push({
              name: 'leadDetails',
              params: { leadId: leadid }
            })
          }, 0)
        }
      } catch (api_error) {
        if (api_error.status === 422) {
          Object.keys(api_error.data.errors).forEach((key) => {
            if (key === 'email') {
              if (api_error.data.errors[key][0] === 'Email already exists') {
                this.errorCount = 1
                this.$vs.notify({
                  title: 'Warning',
                  text: api_error.data.errors[key][0],
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 8000
                })
              }
            }
          })
          if (this.errorCount !== 1) {
            this.$vs.notify({
              title: 'Warning',
              text: 'All fields are required!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
          }
        }
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    handleCreateSidebar () {
      this.isSidebarActiveLocal = false
    },
    setDefault () {
      this.lead.email = ''
      this.lead.phone = ''
      this.lead.lead_first_name = ''
      this.lead.lead_middle_name = ''
      this.lead.lead_last_name = ''
      this.lead.lead_address1 = ''
      this.lead.lead_address2 = ''
      this.lead.lead_city = ''
      this.lead.lead_state = ''
      this.lead.lead_zip = ''
      this.errorCount = 0
      this.lead.multi_user = false
      this.api_response_message_show = ''
      this.api_response_message = ''
      //   for(let eachObject,key) in this.dynamicFormObject)
      Object.keys(this.dynamicFormObject).forEach((key) => {
        this.dynamicFormObject[key] = ''
      })
      this.$validator.reset()
    }
  },
}
</script>

<style scoped>
.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
}

.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */

.custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
}
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}
#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.requiredInput .vs-input--label:after {
  content: ' *';
  color: red;
}
.required:after {
  content: ' *';
  color: red;
}

.vs-row > .vs-col {
  padding: 0 6px;
}

.child-detail-heading {
  color: #4e4f53;
  font-weight: bold;
}

.feather-icon {
  cursor: pointer;
}

.vs-icon {
  cursor: pointer;
}

.child-section {
  padding: 10px;
  background: rgb(236, 244, 244);
}

/* .vs-sidebar .vs-sidebar--items {
  overflow-y: scroll;
} */
</style>